import { observable, action, computed, toJS } from 'mobx';
import { setter } from 'mobx-decorators';
import _ from 'lodash';
import agent from '../../services/web/agent';
import erorrHandler from '../../services/web/erorrHandler';

class GroupMapping {

    @setter @observable ldapServers = [];
    @setter @observable groupEntries;
    @setter @observable groupEntriesOptimized;
    @setter @observable selectedServerId = 0;
    @setter @observable nameContainsPattern = '';
    @setter @observable mappedGruopModel = [];
    
    @observable searchGroupEntriesProgress;

    @observable getLDAPGroupEntriesErrorMessage;

    @action searchGroupEntries(serverId, nameContainsPattern) {

        this.searchGroupEntriesProgress = true;

        return agent.LDAPServers.searchGroupEntries(serverId, nameContainsPattern)
            .then(action((groupEntries) => {

                this.groupEntries = groupEntries;
                
                return groupEntries;
            }))
            .catch(action((err) => {

                this.getLDAPGroupEntriesErrorMessage = erorrHandler.getErrorMessage(err);
        
                throw err;
            }))
            .finally(action(() => {

                this.searchGroupEntriesProgress = false;
            }));
    }

    @action resetForm = () => {

        this.groupEntries = undefined;
        this.nameContainsPattern = '';
    }

    @computed get selectedEntries() {

        if (this.groupEntriesOptimized === undefined) {
            
            return 0;
        }

        return this.groupEntriesOptimized.filter((entry) => entry.selected === true).length;
    }

    @action getNormalizedEntries(entries) {

        return toJS(entries);
    }

    @action appnedEntryId(entry) {

        this.mappedGruopModel.push(entry);
    }

    @action removeEntryId(id) {

        this.mappedGruopModel = _.remove(this.mappedGruopModel, (o) => o.ldapGroupDn !== id);
    }

    @action resetEntries() {

        this.mappedGruopModel = [];
    }
    
    @action resetMappedGruopModel() {

        this.mappedGruopModel = [];
    }

    @action resetGroupEntriesOptimized() {

        this.groupEntriesOptimized = [];
    }
}

export default new GroupMapping();